import styled from 'styled-components'

export const Divider = styled.div`
  height: 1px;
  background-color: rgba(0, 0, 0, 0.05);
`

export const MenuContainer = styled.div`
  padding: 0 16px;

  :last-child ${Divider} {
    display: none;
  }
`

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 24px 0;
  cursor: pointer;
`

export const Photo = styled.div`
  height: 88px;
  width: 88px;
  margin-left: 20px;

  background-color: ${props => props.theme.colors.lighterGrey};
  background-image: url(${props => props.image});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 12px;
`

export const DetailsSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: calc(100% - 88px);
  margin-right: 15px;
`

export const Description = styled.div`
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px;
  font-weight: 500;
  color: #999;
  line-height: 20px;
  margin-top: 8px;
`

export const Price = styled.span`
  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  margin-top: 8px;
`

export const Name = styled.h4`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  word-break: break-word;
  overflow-wrap: break-word;

  font-family: 'Montserrat', sans-serif !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`

export const NameCont = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
`

export const PromoIcon = styled.img`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 16px;
  height: 16px;
  margin-top: 2px;
  margin-right: 8px;
`
